import { render } from "./EmployeeForm.vue?vue&type=template&id=4022b7bb&scoped=true"
import script from "./EmployeeForm.vue?vue&type=script&lang=js"
export * from "./EmployeeForm.vue?vue&type=script&lang=js"

import "./EmployeeForm.vue?vue&type=style&index=0&id=4022b7bb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4022b7bb"]])

export default __exports__